import { createFileRoute } from '@tanstack/react-router'
import { AuditorRequestListRoutePage } from '@/components/auditor-center/AuditorRequestListPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list',
)({
  // `pad: false` — the page owns its own `p-6` body. The auditor Policies page
  // it mirrors reaches the same result the other way (it escapes this shell via
  // `$auditCycleId_` and passes `raw` to its own ScreenataPageLayout); inside
  // the shell, `pad: false` is the equivalent lever.
  staticData: {
    pageHeader: {
      title: 'Information Requests',
      customHeader: true,
      pad: false,
    },
  },
  component: AuditorRequestListRoutePage,
})
